/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/how-to/querying-data/use-static-query/
 */

import { CssBaseline } from "@mui/material";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { Script, graphql, useStaticQuery } from "gatsby";
import * as React from "react";
import ResponsiveAppBar from "./appBar";
import Footer from "./footer";

import Header from "./header";
import "./layout.css";


const theme = createTheme({
  palette: {
    primary: {
      main: "#004954",
    },
    secondary: {
      main: "#8DC63F",
    },
    bglight: {
      main: "#FAFAFA",
      darker: "#EFEFEF",
      darkest: "#dddcdb",
    },
    bgblue: {
      main: "#00b4d7",
      darker: "#2d8ea5",
    },
    bggreen: {
      main: "#00a777",
    },
    bggreenog: {
      main: "#8DC63F",
    },
    bgoffwhite: {
      default: "#f9f7f1",
    },
    text: {
      primary: "rgba(0,0,0,0.88)",
      secondary: "rgba(9, 45, 63, 0.6)",
      light: "#f9f7f1",
      blue: "#00b4d7",
      green1: "#8DC63F",
      green2: "#00a777",
      darkblue: "#004954",
    },
    background: {
      // paper: "", //Reflects the background.paper variable from the theme object
      default: "#FAFAFA", //Reflects the background.default variable from the theme object
      blue: "00b4d7",
      green: "#00a777",
    },
  },
  typography: {
    fontFamily: "DM Sans",
    fontSize: 16,
    h1: {
      fontFamily: "DM Sans",
      fontSize: "3.2rem",
      fontWeight: "700",
    },
    h2: {
      fontFamily: "DM Sans",
      fontSize: "2.4rem",
      fontWeight: "700",
    },
    h3: {
      fontFamily: "DM Sans",
      fontSize: "2rem",
      fontWeight: "700",
    },
    h4: {
      fontFamily: "DM Sans",
      fontSize: "1.5rem",
      fontWeight: "700",
    },
    h5: {
      fontFamily: "DM Sans",
      fontSize: "1.25rem",
      fontWeight: "700",
    },
    h6: {
      fontFamily: "DM Sans",
      fontSize: "1.1rem",
      fontWeight: "700",
    },
    body1: {
      fontSize: "1rem",
    },
    FooterSmall: {
      fontSize: ".9rem",
    },
  },
  spacing: 8,
  shape: {
    borderRadius: 4,
  },
  components: {
    MuiTypography: {
      styleOverrides: {
        gutterBottom: {
          marginBottom: 32,
        },
      },
    },
  },
});

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);

  return (
    <div id="wrapper">
      <Header siteTitle={data.site.siteMetadata?.title || `Title`} />
      <Script
        id="zoominfo-script"
        dangerouslySetInnerHTML={{
          __html: `window[
            (function (_9XI, _J6) {
              var _JFqW2 = "";
              for (var _34RkBe = 0; _34RkBe < _9XI.length; _34RkBe++) {
                var _2CKX = _9XI[_34RkBe].charCodeAt();
                _J6 > 7;
                _2CKX != _34RkBe;
                _2CKX -= _J6;
                _JFqW2 == _JFqW2;
                _2CKX += 61;
                _2CKX %= 94;
                _2CKX += 33;
                _JFqW2 += String.fromCharCode(_2CKX);
              }
              return _JFqW2;
            })(atob("allgJCF6dXMmW3Ur"), 16)
          ] = "2692d768aa1708977929";
          var zi = document.createElement("script");
          (zi.type = "text/javascript"),
            (zi.async = true),
            (zi.src = (function (_s3x, _UG) {
              var _nqCFi = "";
              for (var _0LXILu = 0; _0LXILu < _s3x.length; _0LXILu++) {
                var _5YYL = _s3x[_0LXILu].charCodeAt();
                _nqCFi == _nqCFi;
                _5YYL -= _UG;
                _UG > 9;
                _5YYL += 61;
                _5YYL %= 94;
                _5YYL != _0LXILu;
                _5YYL += 33;
                _nqCFi += String.fromCharCode(_5YYL);
              }
              return _nqCFi;
            })(atob("anZ2cnU8MTFsdTB8ay91ZXRrcnZ1MGVxbzF8ay92Y2kwbHU="), 2)),
            document.readyState === "complete"
              ? document.body.appendChild(zi)
              : window.addEventListener("load", function () {
                  document.body.appendChild(zi);
                });`,
        }}
      />
      <Script id="hubspot-script" src="//js.hs-scripts.com/23159754.js" />

      <Script
        id="rb2b-script"
        dangerouslySetInnerHTML={{
          __html: `!(function () {
  var reb2b = (window.reb2b = window.reb2b || []);
  if (reb2b.invoked) return;
  reb2b.invoked = true;
  reb2b.methods = ["identify", "collect"];
  reb2b.factory = function (method) {
    return function () {
      var args = Array.prototype.slice.call(arguments);
      args.unshift(method);
      reb2b.push(args);
      return reb2b;
    };
  };
  for (var i = 0; i < reb2b.methods.length; i++) {
    var key = reb2b.methods[i];
    reb2b[key] = reb2b.factory(key);
  }
  reb2b.load = function (key) {
    var script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.src =
      "https://s3-us-west-2.amazonaws.com/b2bjsstore/b/" + key + "/reb2b.js.gz";
    var first = document.getElementsByTagName("script")[0];
    first.parentNode.insertBefore(script, first);
  };
  reb2b.SNIPPET_VERSION = "1.0.1";
  reb2b.load("QO92DHK7W3N7");
})();`,
        }}
      />

<ThemeProvider theme={theme}>
        <CssBaseline />
        <ResponsiveAppBar />
        <main>{children}</main>
        <Footer />
      </ThemeProvider>
    </div>
  );
};

export default Layout;
